export default {"src":"https://assets.willie.be/003a5d6bcce39278/_next/static/media/star.9c322525.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};